import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-phone\"><path d=\"M746.666667 85.333333c70.693333 0 128 57.306667 128 128v597.333334c0 70.693333-57.306667 128-128 128H277.333333c-70.693333 0-128-57.306667-128-128V213.333333c0-70.693333 57.306667-128 128-128zM277.333333 170.666667a42.666667 42.666667 0 0 0-42.666666 42.666666v597.333334a42.666667 42.666667 0 0 0 42.666666 42.666666h469.333334a42.666667 42.666667 0 0 0 42.666666-42.666666V213.333333a42.666667 42.666667 0 0 0-42.666666-42.666666z m234.666667 469.333333c35.344 0 64 28.656 64 64s-28.656 64-64 64-64-28.656-64-64 28.656-64 64-64z m128-426.666667a42.666667 42.666667 0 0 1 1.333333 85.312L640 298.666667H384a42.666667 42.666667 0 0 1-1.333333-85.312L384 213.333333h256z\" p-id=\"13940\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/phone.svg
// module id = j445
// module chunks = 22